export default "__VITE_ASSET__OdnFE4ap__"